import titleString from './titleString'
export default function tableAdapter (chart, filters, data, dv) {
  // hacky way of keeping existing titleString functionality
  dv.chart = chart
  let title = titleString(dv)
  // eslint-disable-next-line
  if (dv.pageKey === 'accidents' || dv.pageKey === 'participation_person') {
    title = title.split('By')[0]
  } else {
    title = title.split('Boats')[0] + 'Boats'
  }

  let map = {
    'id': chart.props['tableLabel'],
    'label': chart.props['tableLabel'],
    'value': title,
    'valueSuppressed': 'Notes'
  }
  let transformed = []
  if (data.length) {
    data.forEach(datum => {
      if (Object.keys(datum).includes('value')) {
        transformed.push(Object.keys(datum).reduce((acc, key) => {
          if (map[key]) {
            acc[map[key]] = datum[key] ? datum[key].toLocaleString() : ''
            if (datum[key] === true) {
              acc[map[key]] = 'Suppressed'
            }
            if (String(datum[key]).includes('US-')) {
              acc[map[key]] = datum[key].slice(3)
            }
          }
          return acc
        }, {}))
      } else {
        Object.keys(datum).forEach(dKey => {
          if (!dKey.toLowerCase().includes('suppressed') && dKey !== 'label') {
            let row = {}
            row.Category = dKey + ' ' + datum.label
            row[title] = datum[dKey].toLocaleString()
            row.Notes = datum[dKey + 'Suppressed'] ? 'Suppressed' : ''
            transformed.push(row)
          }
        })
      }
    })
  }
  // strip empty rows
  transformed = transformed.filter(t => Object.values(t).filter(v => v).length > 1)
  return transformed
}
